'use client';

import { usePriceConvert } from '@/lib/PriceContext';
import { CAP_MAP, CAP_COLORS, getCapLabel } from '@/lib/capabilityMap';

interface Capability {
  key: string;
  min_players?: number | null;
  max_players?: number | null;
}

interface Props {
  capabilities: Capability[];
}

export function CapabilityChips({ capabilities }: Props) {
  const { lang } = usePriceConvert();

  const chips = capabilities
    .map(cap => {
      const info = CAP_MAP[cap.key];
      if (!info) return null;
      return {
        key: cap.key,
        label: getCapLabel(info, cap.min_players ?? null, cap.max_players ?? null, lang),
        colors: CAP_COLORS[info.category],
        priority: info.priority,
      };
    })
    .filter(Boolean)
    .sort((a, b) => a!.priority - b!.priority) as { key: string; label: string; colors: { bg: string; border: string; text: string }; priority: number }[];

  if (chips.length === 0) return null;

  return (
    <div className="pdp-caps-row" style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '16px 0 18px' }}>
      {chips.map(chip => (
        <span key={chip.key} style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          fontSize: 11, fontWeight: 700, padding: '5px 11px',
          borderRadius: 999,
          background: 'var(--v4-panel)',
          border: '1px solid var(--v4-border)',
          color: 'var(--v4-fg-2)',
          whiteSpace: 'nowrap',
        }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: chip.colors.text, flexShrink: 0 }} />
          {chip.label}
        </span>
      ))}
    </div>
  );
}
